import { SceneNode } from "@/features/screenplay/components/editor/nodes/SceneNode"
import { renderNodesAsParagraphs } from "@/features/screenplay/components/editor/plugins/SpAIWriterChatPlugin"
import { useSceneStore } from "@/features/shared/stores/scene.store"
import { Button } from "@/shared/components/ui/button"
import { cn } from "@/shared/lib/utils"
import { ScrollArea } from "@radix-ui/react-scroll-area"
import { $getRoot } from "lexical"
import { FileText, X } from "lucide-react"
import { useEffect, useState } from "react"
import { useShotListStore } from "../store/useShotListStore"


const ScenePreviewPanel = ({
    className,

}: {
    className?: string
}) => {

    const { editor } = useSceneStore()

    const [currentSceneContent, setCurrentSceneContent] = useState<any>(null)
    const {
        setShowScenePreview, selectedSceneNode, setSelectedSceneNode
    } = useShotListStore()


    useEffect(() => {
        if (!editor || !selectedSceneNode) return
        editor.read(() => {

            const root = $getRoot();
            root.getChildren().forEach((child) => {
                if (child instanceof SceneNode && child.id === selectedSceneNode.id) {
                    setSelectedSceneNode(child)
                    const currentScene = child.getCurrentSceneContent()
                    setCurrentSceneContent(currentScene)
                }
            });
        })
    }, [editor, selectedSceneNode])
    return (
        <div className={cn("border-l flex flex-col h-full bg-muted/10 overflow-hidden transition-all duration-300", className)}>
            <div className="p-3 border-b flex justify-between items-center bg-background flex-none">
                <h3 className="font-semibold text-sm flex items-center gap-2">
                    <FileText className="h-4 w-4" />
                    Scene Script
                </h3>
                <Button variant="ghost" size="icon" className="h-7 w-7" onClick={() => setShowScenePreview(false)}>
                    <X className="h-4 w-4" />
                </Button>
            </div>
            <ScrollArea className="flex-1 w-full p-0">
                <div className="m-4" />
                {currentSceneContent && renderNodesAsParagraphs(currentSceneContent)}
            </ScrollArea>
        </div>

    )
}

export default ScenePreviewPanel